import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/assignNamespace";
import { data } from "./utils";

/**
 *
 *
 */
export function setScrollRestoration(scrollRestoration: ScrollRestoration): void {
  if (data.hasNative) {
    window.history.scrollRestoration = scrollRestoration;
  }
}

/**
 *
 */
export function resetScrollRestoration(): void {
  setScrollRestoration(data.initial as ScrollRestoration);
}

assignNamespace(o_util, "history", {
  setScrollRestoration,
  resetScrollRestoration,
});
